import AppConfig from '@/AppConfig';
export default class Profile {
  // id: number;
  // ssoid: string;
  id: string;
  teamName: string;
  playerName: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  stateId: number;
  postalCode: string;
  countryId: number;
  firestoneId: string;

  constructor(starter?: any) {
    starter = starter || {};
    this.id = starter.id || null;
    this.emailAddress = starter.emailAddress || null;
    this.teamName = starter.teamName || null;
    this.playerName = starter.playerName || null;
    this.firstName = starter.firstName || null;
    this.lastName = starter.lastName || null;
    this.emailAddress = starter.emailAddress || null;
    this.addressLine1 = starter.addressLine1 || null;
    this.addressLine2 = starter.addressLine2 || null;
    this.city = starter.city || null;
    this.stateId = starter.stateId || null;
    this.postalCode = starter.postalCode || null;
    this.countryId = starter.countryId || 0;
    this.firestoneId = starter.firestoneId || null;
  }
  toObj() {
    return JSON.parse(JSON.stringify(this));
  }
}
